import moment from "moment"
import config from "./config"
import _ from "lodash"

export const dateFormat = (date) => {
    return moment(date).format("DD/MM/YYYY")
}

export const dateToString = (date) => {
    // return moment(date).format("DD MMM, YYYY");
    return moment.utc(date).format("DD MMM YYYY");
}

export const dateTimeFormat = (date) => {
    return moment(date).format("DD/MM/YYYY hh:mm A")
}

export const dateFormatMonthName = (date) => {
    return moment(date).format("DD MMM YYYY")
}

export const dateTimeFormatMonthName = (date) => {
    return moment(date).format("DD MMM YYYY hh:mm A")
}

export const timeSlotFormat = (time) => {
    return moment(time, "HH:mm:ss").format("hh:mm A")
}
export const timeSlotFormatWithoutAM = (time) => {
    return moment(time, "HH:mm:ss").format("hh:mm")
}

export const dateTimeUTCFormat = (date) => {
    return moment(date).utc().format("DD/MM/YYYY hh:mm A")
}

export const convertTZ = (date, tzString) => {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
}

export const isLogin = () => {
    const LilacDoctorToken = localStorage.getItem('LilacDoctorToken')

    if (LilacDoctorToken) return true
    else return false
}

export const getDoctorToken = () => {
    return localStorage.getItem('LilacDoctorToken') || null
}

export const getDoctor = () => {
    return JSON.parse(localStorage.getItem('LilacDoctor')) || null
}
export const getDoctorActivate = () => {
    return localStorage.getItem('LilacDoctorActivate') || "pending"
}

export const clearAuthData = () => {
    localStorage.removeItem('LilacDoctorToken')
    localStorage.removeItem('LilacDoctor')
    localStorage.removeItem('LilacDoctorActivate')
}

export const s3_cdn = () => {
    return `https://lilac-dtrf-attactments.s3.ap-south-1.amazonaws.com/`
}

export const lilac_doctor_site = () => {
    return `http://lilac-doctor-dev.aiolos.solutions/`
}


export const validateImagePdfFile = (file) => {
    let ext
    if (file.type == "image/jpeg") ext = "jpeg"
    if (file.type == "image/png") ext = "png"
    if (file.type == "application/pdf") ext = "pdf"

    if (ext) {
        return { status: true, ext: ext }
    } else {
        return { status: false }
    }
}

export const validateImageFile = (file) => {
    let ext
    if (file.type == "image/jpeg") ext = "jpeg"
    if (file.type == "image/png") ext = "png"

    if (ext) {
        return { status: true, ext: ext }
    } else {
        return { status: false }
    }
}

export const getS3SingedUrl = async (filename, ext, file, foldername) => {
    return new Promise((resolve, reject) => {
        fetch(`${config.api.base_url}s3/get-singed-url?filename=${filename}&ext=${ext}&folder_name=${foldername}`, {
            method: 'get',
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                // "authorization": `bearer ${getUserToken()}`
            }
        }).then(res => {
            const result = res.json();
            return Promise.all([result]);
        }).then((result) => {
            resolve({ ['url']: result[0].url, ['filename']: `${filename}.${ext}` })
        }).catch(console.log)
    })
}

export const accessCheck = async () => {

};